import type { Track } from "webamp";

export interface RadioStation {
	artist: string;
	channelLabel: string;
	metadata: string;
	name: string;
	route: string;
	stream: string;
}

export const RADIO_STATIONS = [
	{
		route: "/stations/royal-talon",
		name: "Royal Talon Radio",
		channelLabel: "ROYAL TALON RADIO",
		artist: "CHANNEL 01",
		stream: "/stations/royal-talon/radio.mp3",
		metadata: "/stations/royal-talon/now-playing.json",
	},
	{
		route: "/stations/now",
		name: "NOW Master Collection",
		channelLabel: "NOW MASTER COLLECTION",
		artist: "CHANNEL 02",
		stream: "/stations/now/radio.mp3",
		metadata: "/stations/now/now-playing.json",
	},
	{
		route: "/stations/180g-en",
		name: "180g in English",
		channelLabel: "180g in ENGLISH",
		artist: "CHANNEL 03",
		stream: "/stations/180g-en/radio.mp3",
		metadata: "/stations/180g-en/now-playing.json",
	},
	{
		route: "/stations/180g-es",
		name: "180g en Español",
		channelLabel: "180g en ESPAÑOL",
		artist: "CHANNEL 04",
		stream: "/stations/180g-es/radio.mp3",
		metadata: "/stations/180g-es/now-playing.json",
	},
	{
		route: "/stations/180g",
		name: "180g",
		channelLabel: "180g",
		artist: "CHANNEL 05",
		stream: "/stations/180g/radio.mp3",
		metadata: "/stations/180g/now-playing.json",
	},
] as const satisfies readonly RadioStation[];

export function stationTracks(stations: readonly RadioStation[]): Track[] {
	return stations.map((station) => ({
		url: station.stream,
		duration: 0,
		defaultName: `${station.artist} - ${station.channelLabel}`,
		metaData: {
			artist: station.artist,
			title: station.channelLabel,
		},
	}));
}

export function readRememberedStation(
	stations: readonly RadioStation[],
	route: string | null,
): RadioStation {
	return (
		stations.find((station) => station.route === route) ??
		stations[0] ??
		RADIO_STATIONS[0]
	);
}
